import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiShoppingBag, FiMenu, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const { cartCount, setIsCartOpen } = useCart();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 inset-x-0 z-[100] transition-all duration-500 ${
      scrolled ? 'py-3' : 'py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className={`glass-panel rounded-2xl flex items-center justify-between px-6 h-14 transition-all duration-500 ${
          scrolled ? 'bg-zinc-900/90 shadow-2xl' : 'bg-transparent border-transparent'
        }`}>
          <div className="flex items-center gap-12">
            <a href="/" className="text-xl font-black tracking-tighter uppercase flex items-center focus:text-fuchsia-500 outline-none transition-colors">
              Pixel<span className="text-fuchsia-500">Petals</span>
            </a>
            
            <div className="hidden md:flex items-center gap-8">
              {['Drop', 'Bundles', 'Archive', 'FAQ'].map((link) => (
                <a 
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  className="text-[10px] font-black uppercase tracking-[0.2em] text-zinc-400 hover:text-white focus:text-cyan-400 outline-none transition-colors"
                >
                  {link}
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-6">
            <button 
              onClick={() => setIsCartOpen(true)}
              className="relative group p-2 outline-none focus:ring-2 focus:ring-cyan-400 rounded-lg transition-all"
              aria-label={`Open cart with ${cartCount} items`}
            >
              <SafeIcon icon={FiShoppingBag} className="text-xl text-zinc-300 group-hover:text-cyan-400 transition-colors" />
              <AnimatePresence>
                {cartCount > 0 && (
                  <motion.span 
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0 }}
                    className="absolute top-1 right-1 w-4 h-4 bg-fuchsia-500 text-[9px] font-black flex items-center justify-center rounded-full text-white shadow-[0_0_10px_rgba(217,70,239,0.6)]"
                  >
                    {cartCount}
                  </motion.span>
                )}
              </AnimatePresence>
            </button>
            <button 
              className="md:hidden p-2 outline-none focus:text-fuchsia-500 transition-colors"
              onClick={() => setMobileMenu(!mobileMenu)}
              aria-label="Toggle menu"
            >
              <SafeIcon icon={mobileMenu ? FiX : FiMenu} className="text-xl text-white" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {mobileMenu && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-full inset-x-0 mx-6 mt-2 glass-panel rounded-2xl p-6 md:hidden z-50"
          >
            <div className="flex flex-col gap-6">
              {['Drop', 'Bundles', 'Archive', 'FAQ'].map((link) => (
                <a 
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  onClick={() => setMobileMenu(false)}
                  className="text-lg font-black uppercase tracking-widest text-zinc-300 hover:text-fuchsia-500 transition-colors"
                >
                  {link}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;